<template>
  <div class="container-fluid" id="result">
		<Navigation></Navigation>
    <div class="row wrapper">
      <div class="col-12 col-md-4 d-print-none side-banner">
        <div class="header">
			<!-- <div id="steps" class="steps" tabindex="0" role="document">
				<span>Step 5</span> of 7
			</div> -->
			<div class="company-logo"></div>
			<h1 tabindex="0">Your cover estimate</h1>
			<div class="hero-image" alt="Your cover estimate"></div>
        </div>
      </div>

      <div class="col-12 col-md-8 main-banner">
        <div class="main">
			<!-- Print only   -->
			<div v-if="!this.skipCalculations" class="d-none d-print-block print-result mt-4 mb-5">
				<div v-if="this.$route.name != 'CoverCost'" class="logos">
					<img :src="require(`@/assets/img/${pageContent.companyLogo}`)" class="d-print-block d-none logo-img" alt="">
				</div>
				<h1 class="print-page-title">
					Your insurance needs result
				</h1>
				<p>
					These results are subject to the limitations and assumptions used by the calculator. When considering these results, you should ensure that you understand the limitations and assumptions.
					<br><br>
					These results are generated on <strong>{{ new Date().toDateString() }}</strong>.
				</p>
				<h2>
					Your inputs
				</h2>
				<table class="table table-striped">
					<tbody>
						<tr>
							<td class="first-column">Age</td>
							<td>{{this.data.stepData.age}}</td>
						</tr>
						<tr>
							<td>Your sex at birth</td>
							<td>{{this.data.stepData.gender[0].toUpperCase() + this.data.stepData.gender.slice(1)}}</td>
						</tr>
						<tr>
							<td>Family type</td>
							<td>
								<div v-if="this.data.stepData.familyType === Enum.familyType.SINGLE">Single</div>
								<div v-if="this.data.stepData.familyType === Enum.familyType.COUPLE">Couple</div>
								<div v-if="this.data.stepData.familyType === Enum.familyType.SINGLE_DEPENDANT">Single with {{this.dependants.length}} dependant(s)</div>
								<div v-if="this.data.stepData.familyType === Enum.familyType.COUPLE_DEPENDANT">Couple with {{this.dependants.length}} dependant(s)</div>
							</td>
						</tr>
						<tr>
							<td>Accommodation expenses</td>
							<td>
								<span v-if="this.data.stepData.homeType == 'None'">-</span>
								<span v-if="this.data.stepData.homeType == 'Mortgage'">Mortgage of ${{formatCurrency(this.data.stepData.mortgageAmount, true)}}</span>
								<span v-if="this.data.stepData.homeType == 'Rent'">Rent of ${{formatCurrency(this.data.stepData.rentAmount, true)}} / Week</span>
							</td>
						</tr>
						<tr>
							<td>Salary</td>
							<td>
								<span v-if="this.data.stepData.salaryPeriod === 'Month'">${{formatCurrency(this.data.stepData.salaryMonthly, true)}}</span>
								<span v-if="this.data.stepData.salaryPeriod === 'Week'">${{formatCurrency(this.data.stepData.salaryWeekly, true)}}</span>
								<span v-if="this.data.stepData.salaryPeriod === 'Year'">${{formatCurrency(this.data.stepData.salaryYearly, true)}}</span>
								/ {{this.data.stepData.salaryPeriod}}
							</td>
						</tr>
						<tr>
							<td>Savings</td>
							<td>${{formatCurrency(this.data.stepData.savings, true)}} </td>
						</tr>
						<tr>
							<td>Debt</td>
							<td>
								<div v-if="this.debts && this.debts.length != 0" >
									<div v-for="(n, ind) in this.debts" :key="'debts'+ind">
										<span v-if="n.Amount > 0">{{n.Name}} : ${{formatCurrency(n.Amount, true)}}</span>
									</div>
								</div>
								<div v-else>
									-
								</div>
							</td>
						</tr>
						<tr>
							<td>Assets</td>
							<td>
								<div  v-if="this.assets && this.assets.length != 0">
									<div v-for="(n, ind) in this.assets" :key="'assets'+ind">
										<span v-if="n.Amount > 0">{{n.Name}} : ${{formatCurrency(n.Amount, true)}}</span>
									</div>
								</div>
								<div v-else>
									-
								</div>
							</td>
						</tr>
						<tr>
							<td>Living expenses</td>
							<td>
								<div v-if="detailedExpenses">
									<div v-for="(n, ind) in this.expenses" :key="'expenses'+ind">
										<span v-if="n.Amount > 0">{{n.Name}} : ${{formatCurrency(n.Amount, true)}}</span>
									</div>
									<hr>
									Total: ${{formatCurrency(this.livingExpenses, true)}} / Month
								</div>
								<div v-else>
									${{formatCurrency(this.data.stepData.expensesAmountPerMonth, true)}} / Month
								</div>

							</td>
						</tr>
						<tr>
							<td>Education expenses per year</td>
							<td>
								<ul v-if="this.data.stepData.familyType === Enum.familyType.SINGLE_DEPENDANT || this.data.stepData.familyType === Enum.familyType.COUPLE_DEPENDANT">
									<li v-for="(n, ind) in this.dependants" :key="'dependants'+ind">
										<span v-if="n.Amount > 0">For dependant age {{n.Age}} : ${{formatCurrency(n.Amount, true)}}</span>
									</li>
								</ul>
								<div v-else>
									-
								</div>
							</td>
						</tr>
						<tr>
							<td>Disability expenses</td>
							<td>${{formatCurrency(this.data.stepData.disabilityCost, true)}} </td>
						</tr>
						<tr>
							<td>Funeral expenses</td>
							<td>${{formatCurrency(this.data.stepData.funeralExpenses, true)}} </td>
						</tr>

					</tbody>
				</table>

			</div>
			<!-- end Print only -->
			<p :class="skipCalculations ? 'd-none' : ''">{{pageContent.pages.results.introText}}</p>
			<!-- {{graphData}} -->
			<div class="accordion" id="result-accordion" role="tablist" :class="skipCalculations? 'd-none' : ''">
				<b-card no-body class="mb-1">
					<b-button block v-b-toggle.accordion-1 tabindex="0" variant="result" role="tab" header-tag="header">
						<div class="title">Death cover</div>
						<div class="number" v-if="this.engineResults.LifeInsurance">${{formatCurrency(Math.max(Math.round(this.engineResults.LifeInsurance.LifeInsuranceNeed),0), true)}}</div>
					</b-button>
					<b-collapse id="accordion-1" class="d-print-block" v-if="this.engineResults.LifeInsurance" accordion="my-accordion" v-bind:class="{ 'hide-graph': this.engineResults.LifeInsurance.LifeInsuranceNeed <= 0 }">
						<b-card-body>
							<b-card-text>
								<p class="no-insurance-summary" v-html="pageContent.pages.results.deathCoverNotRequiredSummary"></p>
								<div class="insurance-summary">
									<p>{{pageContent.pages.results.deathCoverSummary}}</p>
									<div class="row">
										<div class="col-6">
											<div class="coin-wrapper" aria-hidden="true">
												<div class="progress">
													<div class="progress-bar bg-none" role="progressbar"></div>
													<div class="progress-bar bg-legend-4" role="progressbar" v-for="n in this.graphData.DeathDebtCoin" :key="'debt'+n"></div>
													<div class="progress-bar bg-legend-3" role="progressbar" v-for="n in this.graphData.DeathEducationCoin" :key="'education'+n"></div>
													<div class="progress-bar bg-legend-2" role="progressbar" v-for="n in this.graphData.DeathLivingCoin" :key="'living'+n"></div>
													<div class="progress-bar bg-legend-1" role="progressbar" v-for="n in this.graphData.DeathFuneralCoin" :key="'funeral'+n"></div>
												</div>
											</div>
										</div>
										<div class="col-6 legend-wrapper">
											<div class="legend">
												<div class="item-1" v-if="this.graphData.DeathFuneralCoin > 0"><span class="swatch"></span>Funeral expenses  ({{this.graphData.DeathFuneralPerc}}%)</div>
												<div class="item-2" v-if="this.graphData.DeathLivingCoin > 0"><span class="swatch"></span>Living expenses<span v-if="this.data.stepData.rentAmount > 0"> including rent </span> ({{this.graphData.DeathLivingPerc}}%) </div>
												<div class="item-3" v-if="this.graphData.DeathEducationCoin > 0"><span class="swatch"></span>Education cost  ({{this.graphData.DeathEducationPerc}}%)</div>
												<div class="item-4" v-if="this.graphData.DeathDebtCoin > 0"><span class="swatch"></span>Mortgage and/or debts ({{this.graphData.DeathDebtPerc}}%)</div>
											</div>
										</div>
									</div>
								</div>
							</b-card-text>
						</b-card-body>
					</b-collapse>
				</b-card>

				<b-card no-body class="mb-1">
					<b-button block v-b-toggle.accordion-2 tabindex="0" variant="result" role="tab" header-tag="header">
						<div class="title">Total and Permanent Disablement (TPD) cover</div>
						<div class="number" v-if="this.engineResults.TPDInsurance">${{formatCurrency(Math.max(Math.round(this.engineResults.TPDInsurance.TPDInsuranceNeed),0), true)}}</div>
					</b-button>
					<b-collapse id="accordion-2" class="d-print-block" v-if="this.engineResults.TPDInsurance" accordion="my-accordion" v-bind:class="{ 'hide-graph': this.engineResults.TPDInsurance.TPDInsuranceNeed <= 0 }">
						<b-card-body>
							<b-card-text>
								<p class="no-insurance-summary" v-html="pageContent.pages.results.tpdCoverNotRequiredSummary"></p>
								<div class="insurance-summary">
									<p>{{pageContent.pages.results.tpdcoverSummary}}</p>
									<div class="row">
										<div class="col-6">
											<div class="coin-wrapper" aria-hidden="true">
												<div class="progress">
													<div class="progress-bar bg-none" role="progressbar"></div>
													<div class="progress-bar bg-legend-1" role="progressbar" v-for="n in this.graphData.TPDMortgageCoin" :key="'mortgage'+n"></div>
													<div class="progress-bar bg-legend-2" role="progressbar" v-for="n in this.graphData.TPDDebtCoin" :key="'debt'+n"></div>
													<div class="progress-bar bg-legend-3" role="progressbar" v-for="n in this.graphData.TPDDisabilityCoin" :key="'disability'+n"></div>
													<div class="progress-bar bg-legend-4" role="progressbar" v-for="n in this.graphData.TPDFutureCoin" :key="'future'+n"></div>
												</div>
											</div>
										</div>
										<div class="col-6 legend-wrapper">
											<div class="legend">
												<div class="item-4" v-if="this.graphData.TPDFutureCoin > 0"><span class="swatch"></span>Income supplement* ({{this.graphData.TPDFuturePerc}}%) </div>
												<div class="item-3" v-if="this.graphData.TPDDisabilityCoin > 0"><span class="swatch"></span>Medical needs and disability expenses ({{this.graphData.TPDDisabilityPerc}}%) </div>
												<div class="item-2" v-if="this.graphData.TPDDebtCoin > 0"><span class="swatch"></span>Debts expenses ({{this.graphData.TPDDebtPerc}}%) </div>
												<div class="item-1" v-if="this.graphData.TPDMortgageCoin > 0"><span class="swatch"></span>Mortgage expenses ({{this.graphData.TPDMortgagePerc}}%)</div>
											</div>
										</div>
									</div>
									<div class="mt-3 mb-3">
										<small v-if="pageContent.companyName == 'UniSuper'">
											<strong>Income supplement*</strong> - Income Protection will provide only some of the income you have indicated you require in the event of a Total and Permanent Disablement. TPD cover is used to provide a lump sum from which your remaining income needs can be derived.
										</small>
										<small v-else>
											<strong>Income supplement*</strong> - {{100-editAssumptions.incomeProtectionPercentage}}%  of income net of tax may be covered by TPD cover, the remaining {{editAssumptions.incomeProtectionPercentage}}%  may be covered by Income Protection.
										</small>
									</div>
								</div>
							</b-card-text>
						</b-card-body>
					</b-collapse>
				</b-card>

				<b-card no-body>
					<b-button block v-b-toggle.accordion-3 tabindex="0" variant="result" role="tab" header-tag="header">
						<div class="title">Income Protection (annual)</div>
						<div class="number" v-if="this.engineResults.IncomeProtectionInsurance && this.engineResults.IncomeProtectionInsurance.BenefitLevel_Income_per_month > 0">${{formatCurrency(Math.max(Math.round(this.engineResults.IncomeProtectionInsurance.IPInsuranceNeed),0), true)}}</div>
						<div class="number" v-if="this.engineResults.IncomeProtectionInsurance && this.engineResults.IncomeProtectionInsurance.BenefitLevel_Income_per_month <= 0">$0</div>
					</b-button>
					<b-collapse id="accordion-3" class="d-print-block" v-if="this.engineResults.IncomeProtectionInsurance" accordion="my-accordion"  v-bind:class="{ 'hide-graph': this.engineResults.IncomeProtectionInsurance.BenefitLevel_Income_per_month * 12 <= 0 }">
						<b-card-body>
							<b-card-text>
								<p class="no-insurance-summary" v-html="pageContent.pages.results.incomeProtectionCoverNotRequiredSummary"></p>
								<div class="insurance-summary">
									<p
										v-show="Math.max(Math.round(this.engineResults.IncomeProtectionInsurance.IPInsuranceNeed),0) == 360000">
										The estimate is capped at $360,000 because this is typically the maximum amount of cover available. This is less than {{ editAssumptions.incomeProtectionPercentage }}% of your current income (+{{ editAssumptions.incomeProtectionSuperGuarantee }}% super).
									</p>
									<p>{{(pageContent.pages.results.incomeProtectionCoverSummary)}}</p>
									<div class="row">
										<div class="col-6">
											<div class="coin-wrapper" aria-hidden="true">
												<div class="progress">
													<div class="progress-bar bg-none" role="progressbar"></div>
													<div class="progress-bar bg-legend-5" role="progressbar" v-for="n in Math.round(editAssumptions.incomeProtectionPercentage/10)" :key="'ipp'+n"></div>
													<div class="progress-bar bg-legend-6" role="progressbar" v-for="n in Math.round(10 - (editAssumptions.incomeProtectionPercentage/10))" :key="'ipp2'+n"></div>
												</div>
											</div>
										</div>
										<div class="col-6 legend-wrapper">
											<div class="legend">
												<div class="item-6"><span class="swatch"></span>{{editAssumptions.incomeProtectionPercentage}}% of current income <br>(+{{editAssumptions.incomeProtectionSuperGuarantee}}% super)
													<span>
														<b-button id="tooltip-assumptions-ip" variant="tooltip" aria-label="tooltip assumptions income protection"><i class="icon-help"></i></b-button>
														<b-tooltip target="tooltip-assumptions-ip" placement="top">
															The default of 75% reflects the Australian Prudential Regulation Authority’s (APRA) proposed maximum for any benefit period beyond the first 6 months, effective from 1 October 2021. For the first 6 months of the benefit period, a maximum of 90% of your income can be replaced.
														</b-tooltip>
													</span>
												</div>
											</div>
										</div>
									</div>
								</div>
							</b-card-text>
						</b-card-body>
					</b-collapse>
				</b-card>
			</div>

			<div class="d-print-none" v-html="pageContent.pages.results.outroText"></div>

			<div class="d-none d-print-block print-result mt-4 mb-5 pagebreak">
				<div v-html="pageContent.pages.disclaimerCopy"></div>
			</div>

			<button class="link print-button col d-print-none " onclick="window.print();">
				<i class="icon-print"> </i>Print and Download PDF
			</button>
			<!-- ADD PDF FUNCTIONALITY -->
			<!-- <button class="link print-button col d-print-none ml-3 " onclick="window.print();">
				<i class="icon-pdf"> </i>Download PDF
			</button> -->


          <div class="nav-button row d-print-none">
            <router-link class="assumption-button col " :to="{ name: 'Assumptions', params: {activeTab: 'assumptions' } }" tabindex="0" role="button"><i class="icon-edit"></i> Edit assumptions </router-link>
            <router-link class="back-button col" to="/expenses" tabindex="0" role="button">Back</router-link>
            <router-link class="next-button col" to="/next-options" tabindex="0" role="button">Next</router-link>
          </div>

        </div>
      </div>
    </div>
	<CustomFooter></CustomFooter>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { mapFields } from "vuex-map-fields";
import CustomFooter from '../components/CustomFooter';
import Navigation from "../components/Navigation.vue";

export default {
  name: 'Results',
  components: {CustomFooter, Navigation},
	computed: {
		...mapFields(["skipCalculations", "resetCoverFromNeeds", "gender", "prevTab", "constants"]),
		...mapActions(["getEngineResults"]),
		...mapGetters(["engineResults","editAssumptions", "pageContent", "Enum", "data", "dependants", "debts", "expenses", "assets", "detailedExpenses", "api"]),
		salary() {
			const stepData = this.data.stepData;
			const salaryPeriod = stepData.salaryPeriod;
      return salaryPeriod === "Month" ? stepData.salaryMonthly * 12 :
        salaryPeriod === "Week" ? stepData.salaryWeekly * this.constants.WEEKS_PER_YEAR :
        stepData.salaryYearly;
    }
	},
	mounted() {
		this.getEngineResults;

		// Graph
		this.graphData = {
			DeathFuneralExpenses:0, DeathLivingExpenses:0, DeathEducationExpenses:0, DeathDebtExpenses:0, TPDDisabilityExpenses:0, TPDFutureIncome:0, TPDDebtExpenses:0, TPDMortgageExpenses:0, DeathFuneralCoin:0, DeathLivingCoin:0, DeathEducationCoin:0, DeathDebtCoin:0, TPDDisabilityCoin:0, TPDFutureCoin:0, TPDDebtCoin:0, TPDMortgageCoin:0, DeathFuneralPerc:0, DeathLivingPerc:0, DeathEducationPerc:0, DeathDebtPerc:0, TPDDisabilityPerc:0, TPDFuturePerc:0, TPDDebtPerc:0, TPDMortgagePerc:0, TotalDeathCover:0, TotalTPDCover:0
		};

		function getTotal(myExpenses) {
			let myTotal = 0
			if(myExpenses){
				for(var i = 0, len = myExpenses.length; i < len; i++) {
					myTotal += myExpenses[i].ContributionToInsuranceNeed;
				}
			}
			return Number(myTotal);
		}

		function getCoin (myExpenses, myTotalExpenses){
			let perc = 0;
			if(myExpenses){
				perc = myExpenses / myTotalExpenses * 100;

				if(perc > 0 && perc < 15) {
					return 1
				}
				else if(perc > 14 && perc < 25) {
					return 2
				}
				else if(perc > 24 && perc < 35) {
					return 3
				}
				else if(perc > 34 && perc < 45) {
					return 4
				}
				else if(perc > 44 && perc < 55) {
					return 5
				}
				else if(perc > 54 && perc < 65) {
					return 6
				}
				else if(perc > 64 && perc < 75) {
					return 7
				}
				else if(perc > 74 && perc < 85) {
					return 8
				}
				else if(perc > 84 && perc < 95) {
					return 9
				}
				else if(perc > 94)  {
					return 10
				}
			}
		}

		function getPercentage (myExpenses, myTotalExpenses){
			let calculatedPercentage = 0;
			if(myExpenses){
				calculatedPercentage = (myExpenses / myTotalExpenses * 100).toFixed(2);
			}
			return calculatedPercentage;
		}


		// Life insurance
		this.graphData.DeathFuneralExpenses = getTotal(this.engineResults.LifeInsurance.LiabilitiesToMeet.filter(o => o.Type === "Immediate expense"))
		this.graphData.DeathLivingExpenses = getTotal(this.engineResults.LifeInsurance.LiabilitiesToMeet.filter(o => o.Name === "Living")) + getTotal(this.engineResults.LifeInsurance.LiabilitiesToMeet.filter(o => o.Name === "Rent"));
		this.graphData.DeathEducationExpenses = getTotal(this.engineResults.LifeInsurance.LiabilitiesToMeet.filter(o => o.Name === "Education costs"));
		this.graphData.DeathDebtExpenses = getTotal(this.engineResults.LifeInsurance.LiabilitiesToMeet.filter(o => o.Type === "Debt")) + getTotal(this.engineResults.LifeInsurance.LiabilitiesToMeet.filter(o => o.Type === "Repay mortgage"));
		this.graphData.TotalDeathCover = this.graphData.DeathFuneralExpenses + this.graphData.DeathLivingExpenses + this.graphData.DeathEducationExpenses + this.graphData.DeathDebtExpenses;
		// TPD insurance
		this.graphData.TPDDisabilityExpenses = getTotal(this.engineResults.TPDInsurance.LiabilitiesToMeet.filter(o => o.Type === "Immediate expense"));
		this.graphData.TPDFutureIncome = getTotal(this.engineResults.TPDInsurance.LiabilitiesToMeet.filter(o => o.Type === "Future income"));
		this.graphData.TPDDebtExpenses = getTotal(this.engineResults.TPDInsurance.LiabilitiesToMeet.filter(o => o.Type === "Debt"));
		this.graphData.TPDMortgageExpenses = getTotal(this.engineResults.TPDInsurance.LiabilitiesToMeet.filter(o => o.Type === "Repay mortgage"));
		this.graphData.TotalTPDCover = this.graphData.TPDDisabilityExpenses + this.graphData.TPDFutureIncome + this.graphData.TPDDebtExpenses + this.graphData.TPDMortgageExpenses;
		// Coin calculation
		this.graphData.DeathFuneralCoin = getCoin(this.graphData.DeathFuneralExpenses,this.graphData.TotalDeathCover);
		this.graphData.DeathLivingCoin = getCoin(this.graphData.DeathLivingExpenses,this.graphData.TotalDeathCover);
		this.graphData.DeathEducationCoin =  getCoin(this.graphData.DeathEducationExpenses,this.graphData.TotalDeathCover);
		this.graphData.DeathDebtCoin =   getCoin(this.graphData.DeathDebtExpenses,this.graphData.TotalDeathCover);
		this.graphData.TPDDisabilityCoin =  getCoin(this.graphData.TPDDisabilityExpenses,this.graphData.TotalTPDCover);
		this.graphData.TPDFutureCoin =  getCoin(this.graphData.TPDFutureIncome,this.graphData.TotalTPDCover);
		this.graphData.TPDDebtCoin =   getCoin(this.graphData.TPDDebtExpenses,this.graphData.TotalTPDCover);
		this.graphData.TPDMortgageCoin =  getCoin(this.graphData.TPDMortgageExpenses,this.graphData.TotalTPDCover);
		// % calculation
		this.graphData.DeathFuneralPerc = getPercentage(this.graphData.DeathFuneralExpenses,this.graphData.TotalDeathCover);
		this.graphData.DeathLivingPerc = getPercentage(this.graphData.DeathLivingExpenses,this.graphData.TotalDeathCover);
		this.graphData.DeathEducationPerc =  getPercentage(this.graphData.DeathEducationExpenses,this.graphData.TotalDeathCover);
		this.graphData.DeathDebtPerc =   getPercentage(this.graphData.DeathDebtExpenses,this.graphData.TotalDeathCover);
		this.graphData.TPDDisabilityPerc =  getPercentage(this.graphData.TPDDisabilityExpenses,this.graphData.TotalTPDCover);
		this.graphData.TPDFuturePerc =  getPercentage(this.graphData.TPDFutureIncome,this.graphData.TotalTPDCover);
		this.graphData.TPDDebtPerc =   getPercentage(this.graphData.TPDDebtExpenses,this.graphData.TotalTPDCover);
		this.graphData.TPDMortgagePerc =  getPercentage(this.graphData.TPDMortgageExpenses,this.graphData.TotalTPDCover);

		// calculate total living expenses
		var total = 0;
		if(this.detailedExpenses) {
			this.expenses.forEach(expense => {
				total += expense.Amount;
			})
		}
		else {
			total = this.data.stepData.expensesAmountPerMonth;
		}
		this.livingExpenses = total;

		if(!this.skipCalculations && this.resetCoverFromNeeds) {
			this.$store.commit("updateResetCoverFromNeeds", false);

			this.$gtag.event('step-needs', { event_category: 'result-data', event_label: JSON.stringify({
				"deathCover": this.engineResults.LifeInsurance.LifeInsuranceNeed,
				"TPDCover": this.engineResults.TPDInsurance.TPDInsuranceNeed,
				"IPCover": this.engineResults.IncomeProtectionInsurance.IPInsuranceNeed
			})});

			const stepData = this.data.stepData;
			const apiData = {
				id: this.api.userUUID,
				age: stepData.age,
				gender: stepData.gender,
				salary: this.salary,
				needs: {
					familyType: stepData.familyType,
					homeType: stepData.homeType,
					dependants: this.dependants.length,
					mortgage: stepData.mortgageAmount,
					rent: stepData.rentAmount,
					debt: this.debts.reduce((n, {Amount}) => n + Amount, 0),
					savings: stepData.savings,
					assets: this.assets.reduce((n, {Amount}) => n + Amount, 0),
					expenses: this.livingExpenses,
					education: this.dependants.reduce((n, {Amount}) => n + Amount, 0),
					disability: stepData.disabilityCost,
					funeral: stepData.funeralExpenses,
					needsDeathCover: this.engineResults.LifeInsurance.LifeInsuranceNeed,
					needsTpdCover: this.engineResults.TPDInsurance.TPDInsuranceNeed,
					needsIpCover: this.engineResults.IncomeProtectionInsurance.IPInsuranceNeed
				}
			};

			this.api.client.post(this.api.path, apiData).catch(err => (console.log(err)));
		}

    this.triggerHeightCheck();
    this.$scrollIframeTop();
    window.addEventListener("resize", this.$refreshIframeHeight);

    // add click function for accordions
    document.querySelectorAll(".btn-result").forEach(accordionBtn =>
      accordionBtn.addEventListener('click', this.triggerSlowHeightCheck)
    );
	},
  destroyed() {
	if (this.prevTab < 5 ) {
		this.prevTab = 5;
	}
    window.removeEventListener("resize", this.$refreshIframeHeight);
  },
	data() {
		return {
			graphData:0,
			livingExpenses: 0,
		};
	},
	methods: {
		formatCurrency: (value, noCents = false) => {
		return value === null
			? ""
			: noCents
			? value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
			: parseFloat(value)
				.toFixed(2)
				.toString()
				.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
		},
    triggerHeightCheck: function() {
      // Add slight delay otherwise incorrect height is read
      var rf = this;
      setTimeout(function() {
        rf.$refreshIframeHeight();
      }, 300);
    },
    triggerSlowHeightCheck: function() {
      // Add slight delay otherwise incorrect height is read
      var rf = this;
      setTimeout(function() {
        rf.$refreshIframeHeight();
      }, 800);
    }
	},
}


</script>
